const $sample_atc_submit_event = async function($form_data){
    const $sample_addtocart_result = await fetch('/cart/add.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify($form_data)
    });
    const $atc_success_result = await $sample_addtocart_result.json();
    if($atc_success_result.items){
      if (document.querySelector('cart-drawer') && document.querySelector('cart-drawer').classList.contains('is-empty')) document.querySelector('cart-drawer').classList.remove('is-empty');
      const quickAddModal = document.querySelector('quick-add-modal');
      if(quickAddModal){
        document.body.addEventListener('modalClosed', () => {
          setTimeout(() => { document.querySelector('cart-drawer').renderContents($atc_success_result) });
        }, {once: true});
        quickAddModal.hide(true);
      } else{
         if($("body").hasClass("block_cart_drawer")){
           document.querySelector('cart-drawer').renderContents($atc_success_result);
        }else{
         window.location.href = "/cart"
        }
      }
        var freeGiftproduct = $(".block__cart-drawer-shipping-bar-box").attr("free-gift-product");   
        let sample_product_atc_array = [];
              sample_product_atc_array.push({
                id: freeGiftproduct,
                quantity: 1,
                 properties: {
                    "free-gift" :"Free Gift"
                  }
              });
   
            let sample_product_atc_formData = {items:sample_product_atc_array, sections_url:window.location.pathname, sections:document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id)};
           if(!$(".block_free-gift-item").length){ 
                if($(".block__cart-drawer-shipping-bar-box").hasClass("active")){    
                 $sample_atc_submit_event(sample_product_atc_formData);  
                 }
           }
    } else{
      console.error($atc_success_result);
    }
  }
$(document).on("click", ".quick-add__submit", function (e) {
  e.preventDefault(), e.stopImmediatePropagation();
  let sample_product_atc_array = [];
  
    sample_product_atc_array.push({
      id: $(this).parents(".grid__item").find('[name="id"]').attr("value"),
      quantity: 1,
    });

   let sample_product_atc_formData;
  if($("body").hasClass("block_cart_drawer")){      
     sample_product_atc_formData = {items:sample_product_atc_array, sections_url:window.location.pathname, sections:document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id)};
  }else{
    sample_product_atc_formData = {items:sample_product_atc_array};
  }      
    $sample_atc_submit_event(sample_product_atc_formData);
  
});